export const injectTheme = () => {
  const style = document.createElement("style");
  style.textContent = `
    /* Editor con posición relativa */
    .gjs-editor {
      display: flex !important;
      flex-direction: column !important;
      height: 100% !important;
      position: relative !important;
    }

    /* Panel de commands se expande */
    .gjs-pn-panel.gjs-pn-commands {
      flex: 1 !important;
      width: 100% !important;
    }

    /* Panel options a la derecha con absoluto */
    .gjs-pn-panel.gjs-pn-options {
      position: absolute !important;
      right: 0 !important;
      top: 0 !important;
      width: auto !important;
      height: auto !important;
      flex: none !important;
      z-index: 100 !important;
    }

    /* Fuerza que el canvas ocupe todo el espacio */
    .gjs-cv-canvas {
      flex: 1 !important;
      width: 100% !important;
    }

    /* Oculta completamente el panel views */
    .gjs-pn-views,
    .gjs-pn-views-container,
    .gjs-pn-panel.gjs-pn-views {
      display: none !important;
      width: 0 !important;
      height: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      flex: none !important;
    }

    /* Fondo blanco */
    .gjs-one-bg {
      background-color: #fff !important;
    }

    /* Texto gris */
    .gjs-two-color {
      color: #475569 !important;
    }

    /* Fondo gris claro */
    .gjs-three-bg {
      background-color: #f1f5f9 !important;
      color: #475569 !important;
    }

    /* Texto gris oscuro */
    .gjs-four-color,
    .gjs-four-color-h:hover {
      color: #0f172a !important;
    }

    /* Bordes */
    .gjs-layer,
    .gjs-sm-sector,
    .gjs-trait {
      border-color: #e2e8f0 !important;
    }

    /* Hover */
    .gjs-layer:hover,
    .gjs-sm-property:hover {
      background-color: #f1f5f9 !important;
    }

    /* Activo */
    .gjs-layer.gjs-active {
      background-color: #e0e7ff !important;
      color: #2563eb !important;
    }

    /* Input */
    .gjs-field {
      background-color: #fff !important;
      border-color: #e2e8f0 !important;
      color: #0f172a !important;
    }

    .gjs-field:focus {
      border-color: #2563eb !important;
      box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1) !important;
    }

    .gjs-field input,
    .gjs-field select,
    .gjs-field textarea {
      color: #0f172a !important;
    }

    .gjs-sm-sector .gjs-field,
    .gjs-sm-sector .gjs-field input,
    .gjs-sm-sector .gjs-field select,
    .gjs-sm-sector .gjs-field textarea,
    .gjs-sm-composite .gjs-field,
    .gjs-sm-composite .gjs-field input {
      color: #0f172a !important;
    }

    /* Título de sección */
    .gjs-sm-sector-title,
    .gjs-layers-label {
      background-color: #f8fafc !important;
      color: #0f172a !important;
      border-bottom: 1px solid #e2e8f0 !important;
    }

    /* Scroll */
    .gjs-layers::-webkit-scrollbar,
    .gjs-sm-properties::-webkit-scrollbar {
      width: 6px;
    }

    .gjs-layers::-webkit-scrollbar-track,
    .gjs-sm-properties::-webkit-scrollbar-track {
      background: #f1f5f9;
    }

    .gjs-layers::-webkit-scrollbar-thumb,
    .gjs-sm-properties::-webkit-scrollbar-thumb {
      background: #cbd5e1;
      border-radius: 3px;
    }

    .gjs-layers::-webkit-scrollbar-thumb:hover,
    .gjs-sm-properties::-webkit-scrollbar-thumb:hover {
      background: #94a3b8;
    }
  `;

  document.head.appendChild(style);
};